export default "__VITE_ASSET__BqpDpCis__ 640w, __VITE_ASSET__T5WvKFfc__ 900w, __VITE_ASSET__aTtfNejr__ 1254w";